import { OptionalPayment } from '../generated/OptionalPayment';
import { Payments } from '../generated/Payments';
import { Student } from '../generated/Student';

export class PaymentStudentDTO {
  user_id = '';
  nickname = '';
  parent_full_name = '';
  card_token = '';
  lesson_amount = 0;
  optional_amount = 0;
  optional_count = 0;
  already_lesson_count = 0;
  sum_lesson_amount = 0;
  optionalPayment: OptionalPayment[] = [];
  student: Student | undefined = undefined;
}
